import { render, staticRenderFns } from "./YoutubeInsertor.vue?vue&type=template&id=92027c06&scoped=true"
import script from "./YoutubeInsertor.vue?vue&type=script&lang=js"
export * from "./YoutubeInsertor.vue?vue&type=script&lang=js"
import style0 from "./YoutubeInsertor.vue?vue&type=style&index=0&id=92027c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92027c06",
  null
  
)

export default component.exports